export default "__VITE_ASSET__DN1xe3Ms__"